import React, { useState } from "react";
import styles from "./CouponTemplate.module.css";

export default function CouponTemplate1({
  data,
  handleShowCoupon,
  loading,
  handleGenerateCoupon,
  handleSelectCoupon,
  sliderRef,
}) {
  let bgImage = {
    background: `url(${data?.bgImage}) top center / cover`,
  };
  const originalDate = data?.validTill;
  const date = new Date(originalDate);

  const options = { day: "numeric", month: "short", year: "numeric" };
  const formattedDate = date?.toLocaleDateString("en-US", options);
  const handleAddToCart = (coupon) => {
    if (data?.type == "GENERATE") {
      handleGenerateCoupon(data);
    } else {
      handleSelectCoupon(data);
    }
  };
  return (
    <>
      <div className={styles.couponParent1} key={data?._id} ref={sliderRef}>
        <div style={bgImage} className="h-[180px]" />
        <div className="p-[10px] relative">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="297"
            height="201"
            viewBox="0 0 297 201"
            fill="none"
            className="left-0 top-[-70px] w-full absolute z-0"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 3.20292C7.66005 7.17773 15.4548 10.6201 23.309 13.4392C54.1609 22.6469 80.4671 15.6988 106.468 8.83132C137.019 0.762081 167.149 -7.19596 203.738 11.2955C215.86 17.4192 227.481 25.7393 239.193 34.124C252.378 43.5644 265.678 53.0866 279.937 59.6478C285.512 62.1978 291.232 64.4058 297 66.2794V191.162C297 196.133 292.971 200.162 288 200.162H8.99999C4.02943 200.162 0 196.133 0 191.162V3.20292Z"
              fill="white"
            />
          </svg>
          <div className="relative z-1 mt-[-85px]">
            {data?.limited ? (
              <p className={styles.limitedOffer}>Limited Offer</p>
            ) : (
              <div className="h-[40px]" />
            )}
            <h3>{data?.offerText}</h3>
            <p>{data?.conditionText}</p>
            <div className="flex mt-[20px] itams-center justify-between">
              <h4>
                {originalDate && (
                  <>
                    Valid Till: <span>{formattedDate}</span>
                  </>
                )}
              </h4>

              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                onClick={handleAddToCart}
                className="cursor-pointer"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.53333 20.8C8.09813 20.8 6.93333 21.9648 6.93333 23.4C6.93333 24.8352 8.09813 26 9.53333 26C10.9685 26 12.1333 24.8352 12.1333 23.4C12.1333 21.9648 10.9685 20.8 9.53333 20.8ZM18.2 20.8C16.7648 20.8 15.6 21.9648 15.6 23.4C15.6 24.8352 16.7648 26 18.2 26C19.6352 26 20.8 24.8352 20.8 23.4C20.8 21.9648 19.6352 20.8 18.2 20.8ZM9.53333 22.5333C10.0117 22.5333 10.4 22.9216 10.4 23.4C10.4 23.8784 10.0117 24.2667 9.53333 24.2667C9.05493 24.2667 8.66667 23.8784 8.66667 23.4C8.66667 22.9216 9.05493 22.5333 9.53333 22.5333ZM18.2 22.5333C18.6784 22.5333 19.0667 22.9216 19.0667 23.4C19.0667 23.8784 18.6784 24.2667 18.2 24.2667C17.7216 24.2667 17.3333 23.8784 17.3333 23.4C17.3333 22.9216 17.7216 22.5333 18.2 22.5333ZM15.6719 4.33333H4.09153L3.62007 2.91893C3.38347 2.21086 2.72133 1.73333 1.97513 1.73333C1.47853 1.73333 0.866667 1.73333 0.866667 1.73333C0.388267 1.73333 0 2.1216 0 2.6C0 3.0784 0.388267 3.46667 0.866667 3.46667H1.97513L2.63727 5.45133L5.22773 14.9526L5.7642 17.0976C6.05367 18.2546 7.09366 19.0667 8.28706 19.0667H20.8C21.2784 19.0667 21.6667 18.6784 21.6667 18.2C21.6667 17.7216 21.2784 17.3333 20.8 17.3333H8.28706C7.88926 17.3333 7.5426 17.0629 7.44554 16.6773L7.17687 15.6H19.4757C20.6483 15.6 21.6762 14.8157 21.9847 13.6838L22.9519 10.1365C22.9719 10.0646 22.9814 9.9918 22.9823 9.92073C24.7633 9.0948 26 7.2904 26 5.2C26 2.33047 23.6695 0 20.8 0C18.2251 0 16.0853 1.87547 15.6719 4.33333ZM15.6719 6.06667H4.60113L6.7288 13.8667H19.4757C19.8666 13.8667 20.2089 13.6049 20.3121 13.2279L21.086 10.3922C20.9915 10.3974 20.8962 10.4 20.8 10.4C18.2251 10.4 16.0853 8.52453 15.6719 6.06667ZM20.8 1.73333C22.7136 1.73333 24.2667 3.2864 24.2667 5.2C24.2667 7.1136 22.7136 8.66667 20.8 8.66667C18.8864 8.66667 17.3333 7.1136 17.3333 5.2C17.3333 3.2864 18.8864 1.73333 20.8 1.73333ZM19.9333 4.33333H19.0667C18.5883 4.33333 18.2 4.7216 18.2 5.2C18.2 5.6784 18.5883 6.06667 19.0667 6.06667H19.9333V6.93333C19.9333 7.41173 20.3216 7.8 20.8 7.8C21.2784 7.8 21.6667 7.41173 21.6667 6.93333V6.06667H22.5333C23.0117 6.06667 23.4 5.6784 23.4 5.2C23.4 4.7216 23.0117 4.33333 22.5333 4.33333H21.6667V3.46667C21.6667 2.98827 21.2784 2.6 20.8 2.6C20.3216 2.6 19.9333 2.98827 19.9333 3.46667V4.33333Z"
                  fill="black"
                />
              </svg> */}
            </div>
            <button
              onClick={() => handleShowCoupon(data)}
              disabled={loading}
              style={
                data?.selected
                  ? { background: "#55A226", color: "#fff", border: "none" }
                  : {}
              }
            >
              {loading ? <span className={styles.loader} /> : data?.buttonText}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
